import { Routes, Route } from "react-router-dom";
import { Dashboard } from "../../components/dashboard";
import { Descriptive } from "../../components/descriptive";
import { ChatScreen } from "../../components/chat-screen";
import { Quiz } from "../../components/quiz";
import {
  ROUTE_CHAT,
  ROUTE_LEARNING_ASSETS,
  ROUTE_AI_ANALYSIS,
  ROUTE_QUIZ,
  ROUTE_DASHBOARD,
  ROUTE_LOGIN,
  ROUTE_AI_GENERATE,
  ROUTE_PROFILE,
  ROUTE_COMPETITIVE_EXAM,
  ROUTE_DESCRIPTIVE,
} from "..";
import { Login } from "../../components/login";
import { AiGenerator } from "../../components/ai-generator";
import { AiAnalysis } from "../../components/ai-analysis";
import { LearningAssets } from "../../components/learning-assets";
import { CompetitiveExam } from "../../components/competitive-exam";
import { Profile } from "../../components/profile";

export const UserRoutes = () => (
  <Routes>
    <Route path={ROUTE_DASHBOARD} element={<Dashboard />} />
    <Route path={ROUTE_DESCRIPTIVE} element={<Descriptive />} />
    <Route path={ROUTE_CHAT} element={<ChatScreen />} />
    <Route path={ROUTE_QUIZ} element={<Quiz />} />
    <Route path={ROUTE_LOGIN} element={<Login />} />
    <Route path={ROUTE_LEARNING_ASSETS} element={<LearningAssets />} />
    <Route path={ROUTE_AI_GENERATE} element={<AiGenerator />} />
    <Route path={ROUTE_AI_ANALYSIS} element={<AiAnalysis />} />
    <Route path={ROUTE_COMPETITIVE_EXAM} element={<CompetitiveExam />} />
    <Route path={ROUTE_PROFILE} element={<Profile />} />
  </Routes>
);
